import TableFooter from '@material-ui/core/TableFooter';

/** @deprecated */
export default TableFooter;
